export default __webpack_public_path__ + "static/media/period.c33bb562.svg";